import httpClient from '../httpClient';

export async function getDocumentosGestaoSisaf(id: string) {
  try {
    const response = await httpClient.get(`/api/documentossisdaf/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Documentos SisAF: ' + error);
  }
}

export async function getAllDocumentosGestaoSisAf() {
  try {
    const response = await httpClient.get(`/api/documentossisdaf`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Documentos SisAF: ' + error);
  }
}
